const globalConfig = {
  TOKEN: "WEB_TOKEN",
  GROWER_ID: "GROWER_ID",
  SCOUTING_ID: "SCOUTING_ID",
  SEASON_ID: "SEASON_ID",
};

export default globalConfig;
